import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { FormElementBase } from '../form-element-base';

@Component({
  selector: 'checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent extends FormElementBase {
  constructor() {
    super();
  }
}
